(function () {
    window.addEventListener('load', function () {

        var ImageTooltipSpot = {

            classes: {
                HOTSPOT_BODY: '.image-tooltips-spot__body',
                HOTSPOTS_CONTAINER: '.image-tooltips-spot__hotspots',
                SPOT_LABEL: 'label.image-tooltips-spot__label',
                TITLE_LABEL: '.image-tooltips-spot__title--label',
                TOOLTIP: '.image-tooltips-spot__tooltip',
                TOOLTIP_PIN: '.image-tooltips-spot__btn',
                TOOLTIP_INPUT: '.image-tooltips-spot__input',
                TOOLTIP__ARROW: '.image-tooltips-spot__arrow',
                INPUT_BLANK: '#image-tooltips-spot__input--blank',
                ACTIVE_INPUT: 'input.image-tooltips-spot__input[type="radio"]:checked',
                DEFAULT_TRIGGER: '.image-tooltips-spot__default-trigger'

            },
            mapTooltipLabels: function (callback) {
                var spotLabels = document.querySelectorAll(this.classes.SPOT_LABEL);
                Array.prototype.forEach.call(spotLabels, callback);
            },
            mapTooltipsDefaultTriggers: function (callback) {
                var defaultTriggers = document.querySelectorAll(this.classes.DEFAULT_TRIGGER);
                Array.prototype.forEach.call(defaultTriggers, callback);
            },
            setTooltips: function (element) {
                if (window.innerWidth >= 768) this.setDesktopTooltipPos(element, this);
            },
            setDesktopTooltipPos: function (spotLabel) {
                var spotContainer = document.querySelector(this.classes.HOTSPOTS_CONTAINER),
                    spotContainerWidth = spotContainer.offsetWidth,
                    spotBody = document.querySelector(this.classes.HOTSPOT_BODY),
                    gutter = 40,
                    tooltip = spotLabel.querySelector(this.classes.TOOLTIP),
                    windowWidth = window.innerWidth,
                    tooltipPos = spotLabel.offsetLeft,
                    tooltipRightMargin = (spotContainerWidth - tooltip.offsetWidth) - tooltipPos,
                    widthOfTooltipInsideContainer = tooltip.offsetWidth - (-tooltipRightMargin),
                    pullTooltip = (tooltipRightMargin / 2) - tooltipPos,
                    pullTooltipWhenOffGridSmall = (windowWidth < 1000) ? tooltip.offsetWidth - widthOfTooltipInsideContainer : (tooltip.offsetWidth - widthOfTooltipInsideContainer + gutter),
                    tooltipArrow = spotLabel.querySelector(this.classes.TOOLTIP__ARROW),
                    tooltipBottom = spotContainer.offsetHeight - (spotLabel.offsetTop + tooltip.offsetHeight);

                if (windowWidth > 769) {
                    (tooltipRightMargin <= 0) ? tooltip.style.left = "-" + (pullTooltipWhenOffGridSmall) + "px" : tooltip.style.left = "-" + (pullTooltip + gutter) + "px";
                } 
                
                // Sets the arrow button at the utmost left
                var spotOffsetFromTooltipLeft = Math.abs(tooltip.offsetLeft) + (tooltipArrow.offsetWidth / 2) + 5;
                tooltipArrow.style.left = spotOffsetFromTooltipLeft + 'px';
                // Push the next content down when the tooltip is open and is below the component
                if (tooltipBottom < 0 && windowWidth < 769) return spotBody.style.marginBottom = (Math.abs(tooltipBottom) + 100) + "px";
            },
            onSpotClick: function (event) {
                event.stopImmediatePropagation();

                var spotLabel = event.target.closest(this.classes.SPOT_LABEL);
                var tooltip = spotLabel.querySelector(this.classes.TOOLTIP);
                var activeInput = event.target.checked;
                if (activeInput) {
                    this.setTooltips(spotLabel);
                }
                if (window.innerWidth <= 768 && tooltip) {
                    tooltip.style.left = 0;
                }
            },
            onDefaultTrigger: function (event) {
                var hotspot = document.querySelector(this.classes.HOTSPOTS_CONTAINER),
                    blankInput = hotspot.querySelector(this.classes.INPUT_BLANK),
                    spotBody = document.querySelector(this.classes.HOTSPOT_BODY);
                blankInput.checked = true;
                spotBody.style.marginBottom = 0 + "px";

            },
            onResize: function () {
                var hotspot = document.querySelector(this.classes.HOTSPOTS_CONTAINER),
                    activeInput = hotspot.querySelector(this.classes.ACTIVE_INPUT),
                    activeLabel = (activeInput) ? activeInput.parentNode : 'undefined',
                    tooltip = (activeLabel !== 'undefined') ? activeLabel.querySelector(this.classes.TOOLTIP) : 'undefined',
                    spotBody = document.querySelector(this.classes.HOTSPOT_BODY);
                if (window.innerWidth >= 768 && activeLabel !== 'undefined') {
                    this.setDesktopTooltipPos(activeLabel);
                } else {
                    if (activeLabel !== 'undefined' && tooltip !== 'undefined') {
                        tooltip.style.left = 0 + "px";
                    }
                    spotBody.style.marginBottom = 0 + "px";

                }
            },
            init: function () {
                this.mapTooltipLabels(function (element) {
                    element.addEventListener('click', this.onSpotClick.bind(this));
                }.bind(this));
                this.mapTooltipsDefaultTriggers(function (element) {
                    element.addEventListener('click', this.onDefaultTrigger.bind(this));
                }.bind(this));

                window.addEventListener('resize', this.onResize.bind(this));
                // this makes the tooltip overlay to disappear when clicking outside of it
                var blank_input = document.querySelector(ImageTooltipSpot.classes.INPUT_BLANK);
                document.addEventListener('click', function (e) {
                    blank_input.checked = true;
                });
            }
        };

        if (document.querySelector('.image-tooltips-spot__body') !== null) { ImageTooltipSpot.init(); }
    }, false);
})();